import type { ComponentProps } from 'react';
import type { TSelectBase } from 'types/general.types';
import ComboboxMultiple from './ComboboxMultiple';
import ComboboxSingle from './ComboboxSingle';

interface Props extends ComponentProps<'div'> {
  itemName: string;
  items: TSelectBase[];
  disabled?: boolean;
  value?: string | string[];
  isMulti?: boolean;
  onValueChange?: (value: string | string[]) => void;
  triggerClassName?: string;
  contentClassName?: string;
  portalContent?: boolean;
  portalElement?: HTMLElement;
  defaultSort?: boolean;
}

const HubertCombobox = ({
  itemName,
  items,
  disabled = false,
  value,
  isMulti = false,
  onValueChange,
  triggerClassName,
  contentClassName,
  portalContent = false,
  portalElement,
  defaultSort = true,
  ...divProps
}: Props) => {
  let comboboxItems = items;
  if (defaultSort) {
    // Ensure items are displayed in alphabetical order by label
    comboboxItems = [...items].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
  }

  if (isMulti) {
    return (
      <div {...divProps}>
        <ComboboxMultiple
          itemName={itemName}
          items={comboboxItems}
          disabled={disabled}
          onValueChange={onValueChange}
          value={value as string[]}
          triggerClassName={triggerClassName}
          contentClassName={contentClassName}
          portalContent={portalContent}
          portalElement={portalElement}
        />
      </div>
    );
  }

  return (
    <div {...divProps}>
      <ComboboxSingle
        itemName={itemName}
        items={comboboxItems}
        disabled={disabled}
        onValueChange={onValueChange}
        value={value as string}
        triggerClassName={triggerClassName}
        contentClassName={contentClassName}
        portalContent={portalContent}
        portalElement={portalElement}
      />
    </div>
  );
};

export default HubertCombobox;
